// extracted by mini-css-extract-plugin
module.exports = {"noticiaBar":"NoticiasComponent_noticiaBar__1euyK"};